module.exports = __webpack_public_path__ + "img/hire3xai.0ccb0751.svg";